import { render, staticRenderFns } from "./LandingInvestingItem.html?vue&type=template&id=54258ea0&scoped=true&"
import script from "./LandingInvestingItem.ts?vue&type=script&lang=ts&"
export * from "./LandingInvestingItem.ts?vue&type=script&lang=ts&"
import style0 from "./LandingInvestingItem.scss?vue&type=style&index=0&id=54258ea0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54258ea0",
  null
  
)

export default component.exports